import { render } from "./MinuAmetnik.vue?vue&type=template&id=1dc97617&ts=true"
import script from "./MinuAmetnik.vue?vue&type=script&lang=ts"
export * from "./MinuAmetnik.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__